import { saveAs } from 'file-saver';

export const triggerFileDownload = (content: BlobPart, fileName = 'download.txt') => {
  if (!content) {
    console.error('No content provided for download.');
    return;
  }

  try {
    // Determine MIME type based on file extension
    const getMimeType = (filename: string): string => {
      const extension = filename.split('.').pop()?.toLowerCase();
      const mimeTypes: Record<string, string> = {
        txt: 'text/plain',
        pdf: 'application/pdf',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ppt: 'application/vnd.ms-powerpoint',
        pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        csv: 'text/csv',
        json: 'application/json',
        xml: 'application/xml',
        zip: 'application/zip',
        png: 'image/png',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        gif: 'image/gif',
        svg: 'image/svg+xml',
      };
      return mimeTypes[extension || ''] || 'application/octet-stream';
    };

    const mimeType = getMimeType(fileName);
    const blob = new Blob([content], { type: mimeType });

    // Use file-saver's saveAs function
    saveAs(blob, fileName);
  } catch (error) {
    console.error('Error triggering file download:', error);
  }
};
